<template>
  <div class="el-col-24">
    <h5 class="warp-title">系统参数设置</h5>
    <el-card class="main-content-card">
      <el-form ref="addForm" :model="addForm" :rules="addFormRules" class="my-form-style" label-width="auto">
        <el-form-item label="客服最大服务人数" prop="customerMaxPersonNum">
          <el-input v-model="addForm.customerMaxPersonNum" maxlength="2" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="自动关闭会话分钟数" prop="customerMinutesToCloseSession">
          <el-input v-model="addForm.customerMinutesToCloseSession" maxlength="2" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="客服半小时人数百分比" prop="customerPersonNumPercentage">
          <el-input v-model="addForm.customerPersonNumPercentage"></el-input>
          <span class="input-tips-style">客服半小时人数百分比只能在1-99之间</span>
        </el-form-item>
        <el-form-item label="客服预分配人数" prop="customerPreAllocationNum">
          <el-input v-model="addForm.customerPreAllocationNum" maxlength="2" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="服务时间" prop="serviceBeginTime">
          <el-time-picker
            is-range
            v-model="time"
            format="HH:mm:ss"
            value-format="HH:mm:ss"
            range-separator="至"
            start-placeholder="服务开始时间"
            end-placeholder="服务结束时间"
            placeholder="选择时间范围">
          </el-time-picker>
        </el-form-item>
        <el-form-item style="margin-top: 60px;">
          <el-button type="primary" @click="onSubmit" :loading="isSubmitLoading">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import rule from '../../api/public/rule'
import {querySysParam, updateSysParam} from '../../api/system/index'
export default {
  name: 'SystemParams',
  created () {
    this.initData()
  },
  watch: {
    time () {
      if (this.time && this.time.length > 0) {
        this.addForm.serviceBeginTime = this.time[0]
        this.addForm.serviceEndTime = this.time[1]
      } else {
        this.addForm.serviceBeginTime = ''
        this.addForm.serviceEndTime = ''
      }
    }
  },
  data () {
    var validateNum = (r, value, callback) => {
      if (!rule.num.test(value)) {
        callback(new Error('请大于 0 的整数'))
      } else {
        callback()
      }
    }
    var validateNum2 = (r, value, callback) => {
      if (!rule.num.test(value)) {
        callback(new Error('请大于正整数'))
      } else if (Number(value) > 99) {
        callback(new Error('客服半小时人数百分比只能在1-99之间'))
      } else {
        callback()
      }
    }
    return {
      addFormRules: {
        customerMaxPersonNum: [
          { required: true, message: '请输入客服最大服务人数', trigger: 'change' },
          { validator: validateNum, trigger: 'change' }
        ],
        customerMinutesToCloseSession: [
          { required: true, message: '请输入自动关闭会话分钟数', trigger: 'change' },
          { validator: validateNum, trigger: 'change' }
        ],
        customerPersonNumPercentage: [
          { required: true, message: '请输入客服半小时人数百分比', trigger: 'change' },
          { validator: validateNum2, trigger: 'change' }
        ],
        customerPreAllocationNum: [
          { required: true, message: '请输入客服预分配人数', trigger: 'change' },
          { validator: validateNum, trigger: 'change' }
        ],
        serviceBeginTime: [
          { required: true, message: '请选择服务时间', trigger: 'change' }
        ]
      },
      isSubmitLoading: false,
      time: [],
      addForm: {
        customerMaxPersonNum: '',
        customerMinutesToCloseSession: '',
        customerPersonNumPercentage: '',
        customerPreAllocationNum: '',
        serviceBeginTime: '',
        serviceEndTime: ''
      }
    }
  },
  methods: {
    // 获取系统参数配置列表
    initData () {
      querySysParam().then(res => {
        if (res.data.resultCode === 0) {
          this.addForm = res.data.resultData
          this.time = [this.addForm.serviceBeginTime || '', this.addForm.serviceEndTime || '']
        } else {
          this.$message.error(res.data.resultMessage)
        }
      })
    },
    // 编辑系统参数
    onSubmit () {
      this.$refs.addForm.validate(res => {
        if (res) {
          this.isSubmitLoading = true
          updateSysParam(this.addForm).then(res => {
            this.isSubmitLoading = false
            if (res.data.resultCode === 0) {
              this.$message.success('设置成功')
            } else {
              this.$message.error(res.data.resultMessage)
            }
          }).catch(() => {
            this.isSubmitLoading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-form-item__label-wrap{
  margin-left: 0px!important;
}
/deep/.el-input{
  width: 300px;
}
.main-content-card{
  width: 1000px;
}
.input-tips-style{
  font-size: 12px;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/System/Params.vue